import http from '../../../Utils/http';

const FetchOrganizationDetails = {
  name: 'fetchOrganizationDetails',
  state: {
    loading: false,
    error: '',
    details: {}, // Stores organization details
  },
  reducers: {
    detailsRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },
    detailsReceived(state, payload) {
      return {
        ...state,
        loading: false,
        details: payload,
        error: '',
      };
    },
    detailsFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async fetchOrganizationDetails() {
      try {
        this.detailsRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const response = await http.get(`savvy/organization/organizationDetails/${userInfo.org_id}`);
        this.detailsReceived(response.data.data);
      } catch (err) {
        this.detailsFailed(err.response?.data?.error || 'Failed to fetch organization details');
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Failed to fetch organization details',
            open: true,
          },
        });
      }
    },
  }),
};

export default FetchOrganizationDetails;
